import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, shareReplay, switchMap } from 'rxjs/operators';
import { HereLookupResult, HereSearchResult, HereService } from '../here-service.service';

@Component({
  selector: 'lohi-address-search',
  templateUrl: './address-search.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressSearchComponent {
  @Input() public disabled = false;
  @Output() private addressResult = new EventEmitter<HereLookupResult>();

  public addressSearch = new FormControl();
  public addresses$: Observable<HereSearchResult[]>;

  constructor(private hereService: HereService) {
    this.addresses$ = this.addressSearch.valueChanges.pipe(
      debounceTime(300),
      switchMap((v) => {
        if (!v || v?.length < 3) {
          return of([] as HereSearchResult[]);
        }
        return this.hereService.searchForAddresses$(v);
      }),
      shareReplay(1),
    );
  }

  public async selectAddress(address: HereSearchResult) {
    const lookup = await this.hereService.lookup$(address.id).toPromise();
    this.addressResult.next(lookup);
  }
}
